import React, { Component, Fragment } from "react";
import Player from "../Player";
import NameworkVideo from "../Video/NameworkVideo";
import Resttime from "../Resttime";
// import YouTube from '@u-wave/react-youtube';
// import YouTube from 'react-youtube';
import YouTube from "react-youtube";
import Moment from "moment";
import { connect } from "react-redux";
import { getVideo, getVideoExerciseById } from "../../store/actions/GetVideo";
import {
  getExerciseReps,
  nextExercise,
  countProgress,
  clearProgress,
  onBack
} from "../../store/actions/Exercise";
import soundIcon from "../../images/ic_sound.svg";
import muteIcon from "../../images/ic_sound_mute.svg";
import closeIcon from "../../images/ic_close.svg";
import ModalRate from "../Modal/ModalRate";
import { rateType, exerciseType, WEBVIEW_ACTION } from "../../config/config";
import ModalwthWorkout from "../Modal/ModalwthWorkout";
import ProgressBar from "../ProgressBar";
import Back from "../Button/Back";
export class DemoExercise extends Component {
  state = {
    //videoObj: null,
    isPlaying: false,
    isEnd: false,
    isStopped: true,
    isMute: false,
    showResttimePage: false,
    showWorkoutRate: false,
    duration: null,
    isFinished: 1,
    progress: null,
    videos: [],
    currentIndex: 0,
    percent: null,
    video: null
  };
  PlayerState = {
    UNSTARTED: -1,
    ENDED: 0,
    PLAYING: 1,
    PAUSED: 2,
    BUFFERING: 3,
    CUED: 5
  };
  componentDidMount = async () => {
    const { id } = this.props.match.params;
    //console.log(id);
    const video = await this.props.getVideoExerciseById(id);
    if (video) {
      this.setState({ video: video });
    }
    //console.log(this.state.video);
  };
  componentWillUnmount() {
    if (this.playerInterval) {
      clearInterval(this.playerInterval);
    }
  }
  goExcerciseReps = async () => {
    const { id, link } = this.props.match.params;
    console.log(link);
    const { video } = this.state;
    let data = {
      name: video.name,
      reps: video.reps,
      sets: video.sets,
      workoutId: video.id,
      gif: video.gif,
      description: video.description
    };
    await this.props.getExerciseReps(data);
    //check type of exercise
    // videos[currentIndex].type === exerciseType.REPS
    //   ? this.props.history.push("/ExerciseReps")
    //   : this.props.history.push("/ExerciseTimer");
    this.props.history.push(`/DemoExerciseDetail`);
  };
  loadInitialVideo = () => {
    //let videoObj = this.state.videoObj;

    this.videoObj.loadVideoById(this.state.video.video);
    let { index, videos } = this.props;
    if (index === videos.length) {
      this.videoObj.pauseVideo();
    } else {
      //console.log(2)
      this.playButtonToggle();
    }

    /* this.videoObj.stopVideo();
    this.setVideoCountDown(); */
  };
  playButtonToggle = () => {
    //let videoObj = this.state.videoObj;
    if (this.videoObj) {
      let isPlaying = this.state.isPlaying;
      this.setState({ isPlaying: !isPlaying, isStopped: false }, () => {
        if (isPlaying) {
          this.videoObj.pauseVideo();
        } else {
          this.videoObj.playVideo();
        }
      });
    }
  };
  onReady = e => {
    console.log(".....");
    this.videoObj = e.target;
    const duration = this.state.video.duration;
    this.setState({ duration: duration }, () => {
      this.loadInitialVideo();
    });
  };
  onVideoEnd = event => {
    this.setState({ isPlaying: false });
  };
  onVideoPause = () => {
    const isPlaying = this.state.isPlaying;
    if (isPlaying) {
      this.videoObj.pauseVideo();
    }
  };
  onVideoStateChange = event => {
    // console.log("video change");
    if (event.data === this.PlayerState.PLAYING) {
      this.playerInterval = setInterval(() => {
        const duration = this.state.duration - 1;
        // console.log("interval running" + duration);
        if (duration >= 0) {
          this.setState({ duration: duration });
        } else {
          clearInterval(this.playerInterval);
        }
      }, 1000);
    } else {
      clearInterval(this.playerInterval);
    }
  };
  onClosedHandler = () => {
    this.goToAwardedPage();
  };
  onRatedHandler = () => {
    this.goToAwardedPage();
  };
  goToAwardedPage = () => {
    this.props.history.push("/Congratulations/" + this.props.match.params.id);
  };
  modalClose = () => this.setState({ modalShow: false });
  render() {
    const opts = {
      // height: '390',
      width: "100%",
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        playsinline: 1,
        autoplay: 0,
        controls: 0,
        fs: 0,
        rel: 0,
        modestbranding: 1,
        showinfo: 0,
        autohide: 1,
        enablejsapi: 1,
        html5: 1
      }
    };
    const { progressStatus, progress, videos } = this.props;
    const { percent } = this.state;
    console.log(this.state.video);
    return this.state.video ? (
      <div className="video-wrapper">
        {/* <div className="progress prgess-complete">
          {videos.length > 0
            ? videos.map((v, i) => {
                return (
                  <Fragment key={i}>
                    <ProgressBar
                      restTime={this.state.showResttimePage}
                      i={i}
                      percent={percent}
                      progress={progress}
                    />
                  </Fragment>
                );
              })
            : null}
        </div> */}
        <div className="sound">
          <a className="icon" onClick={this.muteToogle}>
            <img src={this.state.isMute ? muteIcon : soundIcon} />
          </a>
          {/* <a
            onClick={() => this.setState({ modalShow: true })}
            className="icon"
          >
            <img src={closeIcon} />
          </a> */}
        </div>
        {this.state.isPlaying ? null : (
          <div
            className="background_youtube fadeIn"
            style={{
              backgroundImage: `url(${
                this.state.video ? this.state.video.thumbnail : null
              })`
            }}
          />
        )}
        <div className="video_iframe">
          <YouTube
            opts={opts}
            onReady={this.onReady}
            onPause={this.onVideoPause}
            onEnd={this.onVideoEnd}
            onStateChange={this.onVideoStateChange}
          />
        </div>
        {!this.state.isPlaying ? (
          <Fragment>
            <div className="player fadeIn" onClick={this.playButtonToggle}>
              <Player className="widthPlay" img="playf2.svg" />
            </div>
          </Fragment>
        ) : (
          <Fragment>
            <div
              className="player player_stop fadeIn"
              onClick={this.playButtonToggle}
            />
          </Fragment>
        )}
        {/* <div className="box_video"> */}
        {/* <div className="box_player"> */}

        <NameworkVideo
          onDemo={true}
          name={this.state.video.name}
          reps={this.state.video.reps}
          sets={this.state.video.sets}
          onClick={this.goExcerciseReps}
          onBack={this.onBack}
        />
        {/* </div> */}
        {/* </div> */}
        {this.state.showResttimePage ? (
          <Resttime
            onComplete={this.restTimeEndHandler}
            onSkip={this.restTimeEndHandler}
          />
        ) : null}
        {/* <ModalRate
          show={this.state.showWorkoutRate}
          onClosed={this.onClosedHandler}
          onRated={this.onRatedHandler}
          id={this.props.match.params}
        /> */}

        {/* <ModalwthWorkout
          show={this.state.modalShow}
          backdrop="static"
          onHide={this.modalClose}
          onClick={this.clearProgress}
        /> */}
      </div>
    ) : null;
  }
}
const mapStateToProps = state => {
  return {
    ...state.workOutList,
    ...state.videosReducer,
    ...state.exerciseReducer,
    ...state.diary
  };
};
export default connect(mapStateToProps, {
  getVideo,
  getExerciseReps,
  nextExercise,
  countProgress,
  clearProgress,
  getVideoExerciseById,
  onBack
})(DemoExercise);
